/** U14 F1: textos da aba Automações (fluxos de conversa em canvas). Entram no namespace `automacoes` como `fluxos`. */
const pt = {
  aba: 'Automações',
  novo: 'Nova automação',
  gatilho: 'Gatilho',
  gatilhos: { app: 'Evento de app externo (Maton)', palavra: 'Palavra-chave no Direct ou no WhatsApp', comentario: 'Comentário em post do Instagram', broadcast: 'Clique em botão de broadcast (WhatsApp)' },
  nome: 'Nome',
  canal: 'Canal',
  canais: { whatsapp: 'WhatsApp', instagram: 'Instagram', qualquer: 'WhatsApp e Instagram' },
  estados: { rascunho: 'Rascunho', ativo: 'Ativa', pausado: 'Pausada', arquivado: 'Arquivada' },
  colunas: { nome: 'Automação', canal: 'Canal', estado: 'Situação', versao: 'Versão', ativas: 'Em andamento', semana: 'Últimos 7 dias', atualizada: 'Atualizada' },
  filtros: { todas: 'Todas', ativas: 'Ativas', pausadas: 'Pausadas', rascunhos: 'Rascunhos', arquivadas: 'Arquivadas' },
  semVersao: 'Não publicada',
  versao: 'v{{n}}',
  vazio: 'Nenhuma automação de conversa ainda. Crie a primeira e desenhe o fluxo no canvas.',
  vazioLeitura: 'Nenhuma automação de conversa ainda.',
  criada: 'Automação criada',
  semConversas: 'O módulo Conversas não está instalado: a automação não envia nada até ele estar.',
  editor: {
    voltar: 'Voltar às automações',
    renomear: 'Renomear',
    salvando: 'Salvando…',
    salvo: 'Rascunho salvo',
    pendente: 'Alterações por salvar',
    erroSalvar: 'Não deu para salvar o rascunho',
    conflito: 'Esta automação foi alterada em outra tela.',
    recarregar: 'Recarregar',
    publicada: 'Publicada (v{{n}})',
    naoPublicada: 'Alterações não publicadas',
    emDia: 'Rascunho igual à versão publicada',
    desfazer: 'Desfazer',
    refazer: 'Refazer',
    organizar: 'Organizar',
    simular: 'Simular',
    testar: 'Testar comigo',
    versoes: 'Versões',
    execucoes: 'Execuções',
    pausar: 'Pausar',
    ativar: 'Ativar',
    arquivar: 'Arquivar',
    desarquivar: 'Desarquivar',
    publicar: 'Publicar',
    publicado: 'Versão {{n}} publicada',
    problemas_one: '{{count}} pendência para publicar',
    problemas_other: '{{count}} pendências para publicar',
    semProblemas: 'Pronto para publicar',
    semPendencias: 'Sem pendências',
    adicionar: 'Adicionar caixa',
    somenteLeitura: 'No celular dá para ver, ligar e desligar a automação. Para editar o fluxo, use o computador.',
    arquivada: 'Automação arquivada: desarquive para editar.',
    canvas: 'Fluxo da automação',
    grupos: { mensagem: 'Mensagens', logica: 'Lógica', acao: 'Ações', gatilho: 'Gatilho' },
    estadoMudou: 'Situação atualizada',
    arquivarTitulo: 'Arquivar a automação?',
    arquivarTexto: 'Os gatilhos param na hora; as conversas em andamento terminam na versão delas.',
  },
  tipos: {
    gatilho_palavra: 'Palavra-chave',
    gatilho_comentario: 'Comentário em post',
    gatilho_broadcast: 'Clique em botão de broadcast',
    resposta_publica: 'Resposta pública',
    resposta_privada: 'Resposta privada',
    oportunidade: 'Abrir oportunidade',
    mensagem: 'Mensagem',
    botoes: 'Botões',
    pergunta: 'Pergunta',
    condicao: 'Condição',
    espera: 'Espera',
    etiqueta: 'Etiqueta',
    transferir: 'Transferir',
    webhook: 'Webhook', gatilho_app: 'Evento de app externo', app_externo: 'Ação em app externo',
    fim: 'Fim',
  },
  saidas: { proximo: 'Depois', sem_resposta: 'Sem resposta', respondeu: 'Respondeu', sim: 'Sim', nao: 'Não', ok: 'Deu certo', erro: 'Deu erro' },
  resumo: {
    app: '{{app}} · {{evento}}',
    appSemEscolha: 'Escolha o app e o evento',
    appExterno: '{{app}}: {{metodo}} {{caminho}}',
    post: 'Post: {{legenda}}',
    qualquerPost: 'Qualquer post',
    qualquerComentario: 'qualquer comentário',
    broadcast: 'Começa quando o contato toca no botão ligado a esta automação no disparo',
    oportunidade: 'Oportunidade: {{titulo}}',
    semPalavras: 'Sem palavra-chave',
    palavras: '{{modo}}: {{lista}}',
    modos: { exata: 'Mensagem exata', contem: 'Contém', palavra: 'Palavra' },
    vazio: 'Sem texto',
    pergunta: 'Guarda em {{variavel}}',
    regras_one: '{{count}} regra ({{juncao}})',
    regras_other: '{{count}} regras ({{juncao}})',
    juncoes: { todas: 'todas', alguma: 'alguma' },
    espera: '{{quantidade}} {{unidade}}',
    unidades: { minutos: 'min', horas: 'h', dias: 'dias' },
    etiquetaPor: 'Põe "{{etiqueta}}"',
    etiquetaTirar: 'Tira "{{etiqueta}}"',
    filaPadrao: 'Fila padrão do canal',
    fila: 'Fila escolhida',
    fim: 'Encerra a automação',
    arquivo: 'Com arquivo',
  },
  painel: {
    broadcastTexto: 'Esta automação começa quando o contato toca num botão de um disparo do Broadcast. No disparo (Automações > Broadcast), ligue o botão a esta automação. Vale só no WhatsApp e só para automação do grupo.',
    appTexto: 'Quando o evento acontece no app, a Maton avisa o MalgoOS e o fluxo roda sem conversa: use condição, espera, webhook e ação em app externo. O evento chega nas variáveis {{a}}, {{b}} e nas outras que começam por evento_ ({{c}} traz tudo).',
    appFonte: 'App',
    appEvento: 'Evento',
    escolha: 'Escolha',
    conexao: 'Conta do app (conexão da Maton)',
    conexaoAjuda: 'As contas ficam na Maton: crie em Integrações > Conectores > Maton.',
    conexaoOutra: 'Conexão {{id}}',
    semConexoes: 'Nenhuma conta ativa deste app na Maton.',
    gatilhoMaton: 'Gatilho na Maton',
    criarNaMaton: 'Criar na Maton',
    gatilhoCriado: 'Gatilho criado na Maton',
    gatilhoFalta: 'Escolha app, evento e conta e use "Criar na Maton": a Maton passa a avisar o MalgoOS desse evento.',
    appExternoTexto: 'Chama a API do app pela Maton, com a conta escolhida. Só as chamadas da lista do app (ler, criar, acrescentar, atualizar); apagar não é permitido.',
    modelo: 'Começar de um modelo',
    modelos: { sheets_linha: 'Google Sheets: acrescentar linha', hubspot_contato: 'HubSpot: criar contato', hubspot_negocio: 'HubSpot: criar negócio' },
    appAcao: 'App',
    metodo: 'Método',
    caminho: 'Caminho da API do app',
    caminhoAjuda: 'Começa por /, sem o nome do app (ex.: /crm/v3/objects/contacts). Variáveis como {{v}} entram codificadas.',
    corpo: 'Corpo (JSON)',
    corpoAjuda: 'Variáveis dentro das aspas, como "{{v}}". Chamada GET vai sem corpo.',
    variavelResposta: 'Guardar a resposta na variável',
    variavelRespostaAjuda: 'Vazio: não guarda. Com id na resposta, o id vai também para <variável>_id.',
    funilIndisponivel: 'Funil indisponível (arquivado ou sem acesso)',
    segueAjuda: 'Pergunta à Meta se o contato segue a conta do Instagram. Sem resposta da Meta, segue pela saída "Não".',
    tipoGatilho: 'Tipo de gatilho',
    tipoGatilhoAjuda: 'Trocar o tipo apaga a configuração do gatilho; as ligações continuam.',
    post: 'Post',
    qualquerPost: 'Qualquer post',
    escolherPost: 'Escolher post',
    verPost: 'Ver no Instagram',
    semLegenda: 'Post sem legenda',
    semPosts: 'A conta não tem posts.',
    carregarMais: 'Carregar mais',
    carregandoPosts: 'Carregando posts…',
    fecharLista: 'Fechar a lista',
    tentarDeNovo: 'Tentar de novo',
    filtroComentario: 'Comentários que disparam',
    filtros: { todos: 'Qualquer comentário', palavras: 'Só com palavras-chave' },
    comentarioRegras: 'Não dispara para comentários da própria conta nem para respostas dentro de outro comentário. Uma automação por pessoa de cada vez.',
    publicaTexto: 'Responde embaixo do comentário, no próprio post. Uma resposta pública por comentário.',
    privadaTexto: 'Abre o Direct com quem comentou. Uma por comentário, até 7 dias depois dele e até 750 por hora na conta (acima disso, espera a próxima vaga).',
    textoComentarioAjuda: 'Use {{usuario}} para o @ de quem comentou e {{comentario}} para o texto do comentário.',
    semOpcoes: 'Sem opções: o fluxo segue direto pela saída "Depois".',
    oportunidadeTexto: 'Abre uma oportunidade no Pipeline para o contato da conversa. Se já houver uma aberta pela conversa, usa essa.',
    tituloOportunidade: 'Título da oportunidade',
    funil: 'Funil',
    funilPadrao: 'Funil padrão',
    titulo: 'Editar caixa',
    excluir: 'Excluir caixa',
    leitura: 'Só leitura',
    texto: 'Texto',
    textoAjuda: 'Use {{variavel}} para inserir uma variável (ex.: {{email}}).',
    palavraVariavel: 'variavel',
    canal: 'Canal',
    palavras: 'Palavras-chave',
    palavrasAjuda: 'Uma por linha.',
    modo: 'Como casa',
    modos: { palavra: 'Palavra inteira na mensagem', contem: 'Contém o texto', exata: 'A mensagem inteira' },
    arquivo: 'Arquivo (só WhatsApp)',
    enviarArquivo: 'Enviar arquivo',
    tirarArquivo: 'Tirar arquivo',
    arquivoEnviado: 'Arquivo enviado',
    tipoBotoes: 'Tipo',
    modosBotoes: { botoes: 'Botões (até 3)', respostas_rapidas: 'Respostas rápidas (até 10)' },
    modosBotoesInstagram: { botoes: 'Botões (até 3)', respostas_rapidas: 'Respostas rápidas (até 13)' },
    opcoes: 'Opções',
    opcao: 'Opção {{n}}',
    novaOpcao: 'Incluir opção',
    tirarOpcao: 'Tirar a opção {{n}}',
    prazo: 'Prazo para responder (horas)',
    prazoAjuda: 'Vazio: espera sem prazo. Com prazo, a caixa ganha a saída "Sem resposta".',
    variavel: 'Guardar a resposta na variável',
    formato: 'Formato da resposta',
    formatos: { texto: 'Texto', numero: 'Número', email: 'E-mail', telefone: 'Telefone' },
    invalida: 'Mensagem quando a resposta não serve',
    juncao: 'Vale quando',
    juncoes: { todas: 'Todas as regras valem', alguma: 'Alguma regra vale' },
    regra: 'Regra {{n}}',
    novaRegra: 'Incluir regra',
    tirarRegra: 'Tirar a regra {{n}}',
    campo: 'Verificar',
    campos: { segue: 'Segue a conta (Instagram)', variavel: 'Variável', etiqueta: 'Etiqueta da conversa', horario: 'Dia e horário', canal: 'Canal' },
    operador: 'Comparação',
    operadores: { segue: 'Segue a conta', nao_segue: 'Não segue a conta', igual: 'É igual a', diferente: 'É diferente de', contem: 'Contém', existe: 'Foi preenchida', nao_existe: 'Está vazia', maior: 'Maior que', menor: 'Menor que', tem: 'Tem', nao_tem: 'Não tem' },
    valor: 'Valor',
    dias: 'Dias da semana',
    diasSemana: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    inicio: 'Das',
    fim: 'Até',
    quantidade: 'Quanto tempo',
    unidade: 'Unidade',
    unidades: { minutos: 'Minutos', horas: 'Horas', dias: 'Dias' },
    acaoEtiqueta: 'O que fazer',
    acoesEtiqueta: { por: 'Pôr a etiqueta', tirar: 'Tirar a etiqueta' },
    etiqueta: 'Etiqueta',
    fila: 'Fila',
    filaPadrao: 'Fila padrão do canal',
    mensagemTransferir: 'Mensagem antes de transferir (opcional)',
    url: 'Endereço (https)',
    urlAjuda: 'Recebe um POST com as variáveis, assinado com o segredo da automação (cabeçalho X-ERP-Signature).',
    segredo: 'Gerar segredo do webhook',
    segredoTitulo: 'Segredo do webhook',
    segredoTexto: 'Copie agora: ele não aparece de novo. Use para conferir a assinatura no seu sistema.',
    copiar: 'Copiar',
    copiado: 'Copiado',
    fimTexto: 'A automação termina aqui.',
  },
  versoes: { titulo: 'Versões publicadas', atual: 'Em uso', restaurar: 'Restaurar no rascunho', restaurada: 'Versão {{n}} trazida para o rascunho', caixas_one: '{{count}} caixa', caixas_other: '{{count}} caixas', vazio: 'Nada publicado ainda.', por: 'por {{nome}}' },
  execucoes: {
    titulo: 'Execuções',
    vazio: 'Nenhuma execução ainda.',
    estados: { rodando: 'Rodando', aguardando: 'Aguardando', concluida: 'Concluída', falhou: 'Falhou', cancelada: 'Cancelada' },
    origens: { app_externo: 'Evento de app', comentario: 'Comentário', gatilho: 'Gatilho', botao: 'Botão', teste: 'Teste' },
    contato: 'Contato',
    inicio: 'Início',
    passos: 'Passos',
    cancelar: 'Cancelar execução',
    cancelada: 'Execução cancelada',
    resultados: { ok: 'OK', erro: 'Erro', aguardando: 'Aguardando' },
    ate: 'até {{quando}}',
  },
  simulador: {
    evento: 'Evento de exemplo: {{app}} · {{evento}}',
    appSemEscolha: 'Escolha o app e o evento no gatilho para simular.',
    segue: 'O contato segue a conta',
    respondeuDirect: 'No Direct, o contato ainda não respondeu: a próxima mensagem só sai depois do clique ou da resposta.',
    comentario: 'Comentário do contato no post',
    comentarioExemplo: 'Ex.: quero o link',
    comentou: 'Comentou: {{texto}}',
    naoCasa: 'O comentário não dispara o gatilho (confira as palavras-chave).',
    publica: 'Resposta pública',
    privada: 'Resposta privada (Direct)',
    semDirect: 'A conversa do Direct só existe depois da resposta privada ao comentário',
    titulo: 'Simular',
    texto: 'Roda o rascunho aqui na tela, sem enviar nada a ninguém.',
    iniciar: 'Começar pelo gatilho',
    reiniciar: 'Recomeçar',
    responder: 'Responder como o contato',
    enviar: 'Enviar',
    tempo: 'Pular a espera',
    canal: 'Canal da simulação',
    etiquetas: 'Etiquetas da conversa',
    terminou: 'Automação terminou: {{motivo}}',
    concluida: 'concluída',
    aguardando: 'Esperando: {{oque}}',
    esperas: { app_externo: 'a resposta do app externo', repetir: 'a próxima vaga de resposta privada', clique: 'o clique num botão', resposta: 'a resposta', tempo: 'o tempo' },
    acao: { appExterno: 'App externo chamado (simulado): {{app}} {{metodo}} {{caminho}}', oportunidade: 'Oportunidade aberta (simulada): {{titulo}}', etiqueta: 'Etiqueta: {{acao}} "{{etiqueta}}"', transferir: 'Conversa entregue à equipe', webhook: 'Webhook chamado (simulado): {{url}}' },
    arquivo: 'Arquivo: {{nome}}',
    problemas: 'O rascunho tem pendências; a simulação pode parar nelas.',
  },
  motivos: {
    evento_inexistente: 'Evento do app não encontrado', app_externo_parado: 'O app externo não respondeu (a automação parou)',
    canal_desconectado: 'O canal não está conectado em Integrações',
    janela_fechada: 'Passaram 24 horas da última mensagem do contato: a mensagem automática não sai (no WhatsApp, só template aprovado)',
    direct_sem_resposta: 'No Direct aberto pela resposta privada, a próxima mensagem só sai depois que a pessoa responder',
    botoes_canal: 'Botões e respostas rápidas só saem pelo WhatsApp oficial e pelo Instagram',
    publica_repetida: 'Este comentário já recebeu a resposta pública',
    comentario_proprio: 'Comentário da própria conta: a automação não responde a si mesma',
    privada_repetida: 'Este comentário já recebeu a resposta privada (a Meta aceita uma por comentário)',
    comentario_7dias: 'Passaram 7 dias do comentário: a Meta não aceita mais a resposta privada',
    sem_contato: 'A conversa não tem contato no Cadastros para abrir a oportunidade',
    sem_pipeline: 'Instale o módulo Pipeline para abrir oportunidades',
    sem_direct: 'A conversa do Direct só existe depois da resposta privada ao comentário',
    nao_comentario: 'Esta execução não começou por um comentário',
    comentario_inexistente: 'Comentário não encontrado', sem_gatilho: 'Fluxo sem gatilho', caixa_inexistente: 'Caixa que não existe nesta versão', variaveis_demais: 'Variáveis demais na execução',
    limite_passos: 'Passou do limite de passos (laço sem espera)', ligacao_gatilho: 'Ligação de volta ao gatilho', transferida: 'Transferida para a equipe',
    conversas_indisponivel: 'O módulo Conversas não está disponível', conversa_inexistente: 'Conversa não encontrada', envio_recusado: 'O provedor recusou a mensagem',
    execucao_parada: 'A execução parou (o servidor não conseguiu continuar)', sem_resposta_prazo: 'Sem resposta em 7 dias', conversa_encerrada: 'Conversa encerrada',
    duplicada: 'Outra execução já estava em andamento na conversa', cancelada_tela: 'Cancelada na tela', erro_interno: 'Erro interno ao executar a caixa', arquivo_inexistente: 'O arquivo da mensagem não existe mais na automação', webhook_parado: 'O webhook não respondeu (a automação parou)',
  },
  passos: {
    app_externo: 'Chamando o app externo', maton_sem_conector: 'Conecte a Maton em Integrações > Conectores', maton_caminho_bloqueado: 'Chamada fora da lista permitida (com as variáveis)', maton_corpo_invalido: 'O corpo ficou inválido com as variáveis', maton_limite: 'A Maton limitou as requisições (10 por segundo)', maton_bloqueado: 'Destino da Maton bloqueado', maton_sem_resposta: 'A Maton não respondeu no prazo',
    conversa_inexistente: 'Conversa não encontrada',
    comentario_inexistente: 'Comentário não encontrado',
    canal_desconectado: 'O canal não está conectado em Integrações',
    janela_fechada: 'Passaram 24 horas da última mensagem do contato: a mensagem automática não sai (no WhatsApp, só template aprovado)',
    direct_sem_resposta: 'No Direct aberto pela resposta privada, a próxima mensagem só sai depois que a pessoa responder',
    botoes_canal: 'Botões e respostas rápidas só saem pelo WhatsApp oficial e pelo Instagram',
    publica_repetida: 'Este comentário já recebeu a resposta pública',
    comentario_proprio: 'Comentário da própria conta: a automação não responde a si mesma',
    privada_repetida: 'Este comentário já recebeu a resposta privada (a Meta aceita uma por comentário)',
    comentario_7dias: 'Passaram 7 dias do comentário: a Meta não aceita mais a resposta privada',
    sem_contato: 'A conversa não tem contato no Cadastros para abrir a oportunidade',
    sem_pipeline: 'Instale o módulo Pipeline para abrir oportunidades',
    sem_direct: 'A conversa do Direct só existe depois da resposta privada ao comentário',
    nao_comentario: 'Esta execução não começou por um comentário',
    limite_hora: 'A conta chegou a 750 respostas privadas na última hora (limite da Meta): nova tentativa em {{quando}}', resposta_publica: 'Resposta pública agendada', resposta_privada: 'Resposta privada enviada', oportunidade_aberta: 'Oportunidade aberta no Pipeline', oportunidade_existente: 'A conversa já tinha uma oportunidade aberta', espera_concluida: 'Espera concluída', sem_resposta: 'Sem resposta no prazo', clique: 'Clique no botão', resposta_opcao: 'Resposta com o texto da opção',
    resposta_invalida: 'Resposta inválida, perguntado de novo', resposta_guardada: 'Resposta guardada em {{valor}}', esperando_clique: 'Esperando o clique',
    esperando_resposta: 'Esperando a resposta', ate: 'Até {{quando}}', transferida: 'Conversa entregue à fila', webhook: 'Chamando o webhook', http: 'HTTP {{status}}',
    webhook_sem_segredo: 'Gere o segredo do webhook na tela da automação', webhook_bloqueado: 'Destino do webhook bloqueado', webhook_sem_resposta: 'O webhook não respondeu no prazo',
    arquivo_enviado: 'Arquivo enviado', envio_recusado: 'O provedor recusou a mensagem', erro_interno: 'Erro interno ao executar a caixa', arquivo_inexistente: 'O arquivo da mensagem não existe mais na automação',
  },
  testar: {
    titulo: 'Testar comigo',
    texto: 'Roda a versão publicada numa conversa sua, com mensagens de verdade: escreva do seu aparelho para o WhatsApp ou o Instagram da empresa, assuma a conversa e escolha-a aqui.',
    conversa: 'Conversa de teste',
    iniciar: 'Começar o teste',
    iniciado: 'Teste começou: veja a conversa',
  },
};

const en: typeof pt = {
  aba: 'Automations',
  novo: 'New automation',
  gatilho: 'Trigger',
  gatilhos: { app: 'External app event (Maton)', palavra: 'Keyword in Direct or WhatsApp', comentario: 'Comment on an Instagram post', broadcast: 'Broadcast button click (WhatsApp)' },
  nome: 'Name',
  canal: 'Channel',
  canais: { whatsapp: 'WhatsApp', instagram: 'Instagram', qualquer: 'WhatsApp and Instagram' },
  estados: { rascunho: 'Draft', ativo: 'Active', pausado: 'Paused', arquivado: 'Archived' },
  colunas: { nome: 'Automation', canal: 'Channel', estado: 'Status', versao: 'Version', ativas: 'In progress', semana: 'Last 7 days', atualizada: 'Updated' },
  filtros: { todas: 'All', ativas: 'Active', pausadas: 'Paused', rascunhos: 'Drafts', arquivadas: 'Archived' },
  semVersao: 'Not published',
  versao: 'v{{n}}',
  vazio: 'No conversation automations yet. Create the first one and draw the flow on the canvas.',
  vazioLeitura: 'No conversation automations yet.',
  criada: 'Automation created',
  semConversas: 'The Conversations module is not installed: the automation sends nothing until it is.',
  editor: {
    voltar: 'Back to automations',
    renomear: 'Rename',
    salvando: 'Saving…',
    salvo: 'Draft saved',
    pendente: 'Changes not saved yet',
    erroSalvar: 'Could not save the draft',
    conflito: 'This automation was changed in another screen.',
    recarregar: 'Reload',
    publicada: 'Published (v{{n}})',
    naoPublicada: 'Unpublished changes',
    emDia: 'Draft matches the published version',
    desfazer: 'Undo',
    refazer: 'Redo',
    organizar: 'Arrange',
    simular: 'Simulate',
    testar: 'Test with me',
    versoes: 'Versions',
    execucoes: 'Runs',
    pausar: 'Pause',
    ativar: 'Activate',
    arquivar: 'Archive',
    desarquivar: 'Unarchive',
    publicar: 'Publish',
    publicado: 'Version {{n}} published',
    problemas_one: '{{count}} issue before publishing',
    problemas_other: '{{count}} issues before publishing',
    semProblemas: 'Ready to publish',
    semPendencias: 'No issues',
    adicionar: 'Add box',
    somenteLeitura: 'On a phone you can view, turn on and turn off the automation. To edit the flow, use a computer.',
    arquivada: 'Archived automation: unarchive it to edit.',
    canvas: 'Automation flow',
    grupos: { mensagem: 'Messages', logica: 'Logic', acao: 'Actions', gatilho: 'Trigger' },
    estadoMudou: 'Status updated',
    arquivarTitulo: 'Archive the automation?',
    arquivarTexto: 'Triggers stop right away; conversations in progress finish on their version.',
  },
  tipos: { gatilho_palavra: 'Keyword', gatilho_comentario: 'Post comment', gatilho_broadcast: 'Broadcast button click', resposta_publica: 'Public reply', resposta_privada: 'Private reply', oportunidade: 'Open opportunity', mensagem: 'Message', botoes: 'Buttons', pergunta: 'Question', condicao: 'Condition', espera: 'Wait', etiqueta: 'Label', transferir: 'Transfer', webhook: 'Webhook', gatilho_app: 'External app event', app_externo: 'External app action', fim: 'End' },
  saidas: { proximo: 'Next', sem_resposta: 'No reply', respondeu: 'Replied', sim: 'Yes', nao: 'No', ok: 'Succeeded', erro: 'Failed' },
  resumo: {
    app: '{{app}} · {{evento}}',
    appSemEscolha: 'Choose the app and the event',
    appExterno: '{{app}}: {{metodo}} {{caminho}}',
    post: 'Post: {{legenda}}',
    qualquerPost: 'Any post',
    qualquerComentario: 'any comment',
    broadcast: 'Starts when the contact taps the button linked to this automation in a broadcast',
    oportunidade: 'Opportunity: {{titulo}}',
    semPalavras: 'No keyword',
    palavras: '{{modo}}: {{lista}}',
    modos: { exata: 'Exact message', contem: 'Contains', palavra: 'Word' },
    vazio: 'No text',
    pergunta: 'Saves to {{variavel}}',
    regras_one: '{{count}} rule ({{juncao}})',
    regras_other: '{{count}} rules ({{juncao}})',
    juncoes: { todas: 'all', alguma: 'any' },
    espera: '{{quantidade}} {{unidade}}',
    unidades: { minutos: 'min', horas: 'h', dias: 'days' },
    etiquetaPor: 'Adds "{{etiqueta}}"',
    etiquetaTirar: 'Removes "{{etiqueta}}"',
    filaPadrao: 'Channel default queue',
    fila: 'Chosen queue',
    fim: 'Ends the automation',
    arquivo: 'With file',
  },
  painel: {
    broadcastTexto: 'This automation starts when the contact taps a button in a Broadcast. In the broadcast (Automations > Broadcast), link the button to this automation. WhatsApp only, group automations only.',
    appTexto: 'When the event happens in the app, Maton notifies MalgoOS and the flow runs without a conversation: use condition, wait, webhook and external app action. The event arrives in the variables {{a}}, {{b}} and the others starting with evento_ ({{c}} has everything).',
    appFonte: 'App',
    appEvento: 'Event',
    escolha: 'Choose',
    conexao: 'App account (Maton connection)',
    conexaoAjuda: 'The accounts stay at Maton: create them in Integrations > Connectors > Maton.',
    conexaoOutra: 'Connection {{id}}',
    semConexoes: 'No active account of this app at Maton.',
    gatilhoMaton: 'Trigger at Maton',
    criarNaMaton: 'Create at Maton',
    gatilhoCriado: 'Trigger created at Maton',
    gatilhoFalta: 'Choose app, event and account and use "Create at Maton": Maton will then notify MalgoOS of this event.',
    appExternoTexto: 'Calls the app API through Maton, with the chosen account. Only the calls on the app list (read, create, append, update); deleting is not allowed.',
    modelo: 'Start from a template',
    modelos: { sheets_linha: 'Google Sheets: append row', hubspot_contato: 'HubSpot: create contact', hubspot_negocio: 'HubSpot: create deal' },
    appAcao: 'App',
    metodo: 'Method',
    caminho: 'App API path',
    caminhoAjuda: 'Starts with /, without the app name (e.g. /crm/v3/objects/contacts). Variables like {{v}} are encoded.',
    corpo: 'Body (JSON)',
    corpoAjuda: 'Variables inside quotes, like "{{v}}". A GET call has no body.',
    variavelResposta: 'Save the response in the variable',
    variavelRespostaAjuda: 'Empty: not saved. With an id in the response, the id also goes to <variable>_id.',
    funilIndisponivel: 'Unavailable pipeline (archived or no access)',
    segueAjuda: 'Asks Meta whether the contact follows the Instagram account. Without an answer from Meta, it goes through the "No" output.',
    tipoGatilho: 'Trigger type',
    tipoGatilhoAjuda: 'Changing the type clears the trigger settings; the connections stay.',
    post: 'Post',
    qualquerPost: 'Any post',
    escolherPost: 'Choose post',
    verPost: 'View on Instagram',
    semLegenda: 'Post without caption',
    semPosts: 'The account has no posts.',
    carregarMais: 'Load more',
    carregandoPosts: 'Loading posts…',
    fecharLista: 'Close the list',
    tentarDeNovo: 'Try again',
    filtroComentario: 'Comments that trigger',
    filtros: { todos: 'Any comment', palavras: 'Only with keywords' },
    comentarioRegras: 'Does not trigger on comments from the account itself or on replies inside another comment. One automation per person at a time.',
    publicaTexto: 'Replies under the comment, on the post itself. One public reply per comment.',
    privadaTexto: 'Opens the Direct with the commenter. One per comment, up to 7 days after it and up to 750 per hour per account (above that, it waits for the next slot).',
    textoComentarioAjuda: 'Use {{usuario}} for the commenter\'s @ and {{comentario}} for the comment text.',
    semOpcoes: 'No options: the flow goes straight to the "Next" output.',
    oportunidadeTexto: 'Opens an opportunity in the Pipeline for the conversation contact. If the conversation already has an open one, uses it.',
    tituloOportunidade: 'Opportunity title',
    funil: 'Pipeline',
    funilPadrao: 'Default pipeline',
    titulo: 'Edit box',
    excluir: 'Delete box',
    leitura: 'Read only',
    texto: 'Text',
    textoAjuda: 'Use {{variavel}} to insert a variable (e.g. {{email}}).',
    palavraVariavel: 'variable',
    canal: 'Channel',
    palavras: 'Keywords',
    palavrasAjuda: 'One per line.',
    modo: 'How it matches',
    modos: { palavra: 'Whole word in the message', contem: 'Contains the text', exata: 'The whole message' },
    arquivo: 'File (WhatsApp only)',
    enviarArquivo: 'Upload file',
    tirarArquivo: 'Remove file',
    arquivoEnviado: 'File uploaded',
    tipoBotoes: 'Type',
    modosBotoes: { botoes: 'Buttons (up to 3)', respostas_rapidas: 'Quick replies (up to 10)' },
    modosBotoesInstagram: { botoes: 'Buttons (up to 3)', respostas_rapidas: 'Quick replies (up to 13)' },
    opcoes: 'Options',
    opcao: 'Option {{n}}',
    novaOpcao: 'Add option',
    tirarOpcao: 'Remove option {{n}}',
    prazo: 'Time to reply (hours)',
    prazoAjuda: 'Empty: waits with no deadline. With a deadline, the box gets the "No reply" output.',
    variavel: 'Save the reply in the variable',
    formato: 'Reply format',
    formatos: { texto: 'Text', numero: 'Number', email: 'Email', telefone: 'Phone' },
    invalida: 'Message when the reply does not fit',
    juncao: 'Holds when',
    juncoes: { todas: 'All rules hold', alguma: 'Any rule holds' },
    regra: 'Rule {{n}}',
    novaRegra: 'Add rule',
    tirarRegra: 'Remove rule {{n}}',
    campo: 'Check',
    campos: { segue: 'Follows the account (Instagram)', variavel: 'Variable', etiqueta: 'Conversation label', horario: 'Day and time', canal: 'Channel' },
    operador: 'Comparison',
    operadores: { segue: 'Follows the account', nao_segue: 'Does not follow the account', igual: 'Equals', diferente: 'Differs from', contem: 'Contains', existe: 'Is filled', nao_existe: 'Is empty', maior: 'Greater than', menor: 'Less than', tem: 'Has', nao_tem: 'Does not have' },
    valor: 'Value',
    dias: 'Weekdays',
    diasSemana: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    inicio: 'From',
    fim: 'To',
    quantidade: 'How long',
    unidade: 'Unit',
    unidades: { minutos: 'Minutes', horas: 'Hours', dias: 'Days' },
    acaoEtiqueta: 'What to do',
    acoesEtiqueta: { por: 'Add the label', tirar: 'Remove the label' },
    etiqueta: 'Label',
    fila: 'Queue',
    filaPadrao: 'Channel default queue',
    mensagemTransferir: 'Message before transferring (optional)',
    url: 'Address (https)',
    urlAjuda: 'Gets a POST with the variables, signed with the automation secret (X-ERP-Signature header).',
    segredo: 'Generate webhook secret',
    segredoTitulo: 'Webhook secret',
    segredoTexto: 'Copy it now: it will not show again. Use it to check the signature on your system.',
    copiar: 'Copy',
    copiado: 'Copied',
    fimTexto: 'The automation ends here.',
  },
  versoes: { titulo: 'Published versions', atual: 'In use', restaurar: 'Restore to draft', restaurada: 'Version {{n}} brought to the draft', caixas_one: '{{count}} box', caixas_other: '{{count}} boxes', vazio: 'Nothing published yet.', por: 'by {{nome}}' },
  execucoes: {
    titulo: 'Runs',
    vazio: 'No runs yet.',
    estados: { rodando: 'Running', aguardando: 'Waiting', concluida: 'Finished', falhou: 'Failed', cancelada: 'Canceled' },
    origens: { app_externo: 'App event', comentario: 'Comment', gatilho: 'Trigger', botao: 'Button', teste: 'Test' },
    contato: 'Contact',
    inicio: 'Started',
    passos: 'Steps',
    cancelar: 'Cancel run',
    cancelada: 'Run canceled',
    resultados: { ok: 'OK', erro: 'Error', aguardando: 'Waiting' },
    ate: 'until {{quando}}',
  },
  simulador: {
    evento: 'Sample event: {{app}} · {{evento}}',
    appSemEscolha: 'Choose the app and the event in the trigger to simulate.',
    segue: 'The contact follows the account',
    respondeuDirect: 'In the Direct, the contact has not replied yet: the next message only goes out after the tap or the reply.',
    comentario: 'Contact comment on the post',
    comentarioExemplo: 'E.g.: send me the link',
    comentou: 'Commented: {{texto}}',
    naoCasa: 'The comment does not fire the trigger (check the keywords).',
    publica: 'Public reply',
    privada: 'Private reply (Direct)',
    semDirect: 'The Direct conversation only exists after the private reply to the comment',
    titulo: 'Simulate',
    texto: 'Runs the draft here on screen, sending nothing to anyone.',
    iniciar: 'Start from the trigger',
    reiniciar: 'Restart',
    responder: 'Reply as the contact',
    enviar: 'Send',
    tempo: 'Skip the wait',
    canal: 'Simulation channel',
    etiquetas: 'Conversation labels',
    terminou: 'Automation ended: {{motivo}}',
    concluida: 'finished',
    aguardando: 'Waiting for {{oque}}',
    esperas: { app_externo: 'the external app response', repetir: 'the next private reply slot', clique: 'a button tap', resposta: 'the reply', tempo: 'the time' },
    acao: { appExterno: 'External app called (simulated): {{app}} {{metodo}} {{caminho}}', oportunidade: 'Opportunity opened (simulated): {{titulo}}', etiqueta: 'Label: {{acao}} "{{etiqueta}}"', transferir: 'Conversation handed to the team', webhook: 'Webhook called (simulated): {{url}}' },
    arquivo: 'File: {{nome}}',
    problemas: 'The draft has issues; the simulation may stop at them.',
  },
  motivos: {
    evento_inexistente: 'App event not found', app_externo_parado: 'The external app did not answer (the automation stopped)',
    canal_desconectado: 'The channel is not connected in Integrations',
    janela_fechada: '24 hours have passed since the last message from the contact: the automatic message does not go out (on WhatsApp, only an approved template)',
    direct_sem_resposta: 'In the Direct opened by the private reply, the next message only goes out after the person replies',
    botoes_canal: 'Buttons and quick replies only go out through official WhatsApp and Instagram',
    publica_repetida: 'This comment already got its public reply',
    comentario_proprio: 'Comment from the account itself: the automation does not reply to itself',
    privada_repetida: 'This comment already got its private reply (Meta accepts one per comment)',
    comentario_7dias: '7 days have passed since the comment: Meta no longer accepts the private reply',
    sem_contato: 'The conversation has no contact in Records to open the opportunity',
    sem_pipeline: 'Install the Pipeline module to open opportunities',
    sem_direct: 'The Direct conversation only exists after the private reply to the comment',
    nao_comentario: 'This run did not start from a comment',
    comentario_inexistente: 'Comment not found', sem_gatilho: 'Flow with no trigger', caixa_inexistente: 'Box that does not exist in this version', variaveis_demais: 'Too many variables in the run',
    limite_passos: 'Over the step limit (loop with no wait)', ligacao_gatilho: 'Connection back to the trigger', transferida: 'Handed to the team',
    conversas_indisponivel: 'The Conversations module is not available', conversa_inexistente: 'Conversation not found', envio_recusado: 'The provider refused the message',
    execucao_parada: 'The run stopped (the server could not continue)', sem_resposta_prazo: 'No reply in 7 days', conversa_encerrada: 'Conversation closed',
    duplicada: 'Another run was already in progress in the conversation', cancelada_tela: 'Canceled on screen', erro_interno: 'Internal error running the box', arquivo_inexistente: 'The message file no longer exists in the automation', webhook_parado: 'The webhook did not answer (the automation stopped)',
  },
  passos: {
    app_externo: 'Calling the external app', maton_sem_conector: 'Connect Maton in Integrations > Connectors', maton_caminho_bloqueado: 'Call outside the allowed list (with the variables)', maton_corpo_invalido: 'The body became invalid with the variables', maton_limite: 'Maton limited the requests (10 per second)', maton_bloqueado: 'Maton destination blocked', maton_sem_resposta: 'Maton did not answer in time',
    conversa_inexistente: 'Conversation not found',
    comentario_inexistente: 'Comment not found',
    canal_desconectado: 'The channel is not connected in Integrations',
    janela_fechada: '24 hours have passed since the last message from the contact: the automatic message does not go out (on WhatsApp, only an approved template)',
    direct_sem_resposta: 'In the Direct opened by the private reply, the next message only goes out after the person replies',
    botoes_canal: 'Buttons and quick replies only go out through official WhatsApp and Instagram',
    publica_repetida: 'This comment already got its public reply',
    comentario_proprio: 'Comment from the account itself: the automation does not reply to itself',
    privada_repetida: 'This comment already got its private reply (Meta accepts one per comment)',
    comentario_7dias: '7 days have passed since the comment: Meta no longer accepts the private reply',
    sem_contato: 'The conversation has no contact in Records to open the opportunity',
    sem_pipeline: 'Install the Pipeline module to open opportunities',
    sem_direct: 'The Direct conversation only exists after the private reply to the comment',
    nao_comentario: 'This run did not start from a comment',
    limite_hora: 'The account reached 750 private replies in the last hour (Meta limit): next try at {{quando}}', resposta_publica: 'Public reply scheduled', resposta_privada: 'Private reply sent', oportunidade_aberta: 'Opportunity opened in the Pipeline', oportunidade_existente: 'The conversation already had an open opportunity', espera_concluida: 'Wait finished', sem_resposta: 'No reply in time', clique: 'Button tap', resposta_opcao: 'Reply with the option text',
    resposta_invalida: 'Invalid reply, asked again', resposta_guardada: 'Reply saved in {{valor}}', esperando_clique: 'Waiting for the tap',
    esperando_resposta: 'Waiting for the reply', ate: 'Until {{quando}}', transferida: 'Conversation handed to the queue', webhook: 'Calling the webhook', http: 'HTTP {{status}}',
    webhook_sem_segredo: 'Generate the webhook secret on the automation screen', webhook_bloqueado: 'Webhook destination blocked', webhook_sem_resposta: 'The webhook did not answer in time',
    arquivo_enviado: 'File sent', envio_recusado: 'The provider refused the message', erro_interno: 'Internal error running the box', arquivo_inexistente: 'The message file no longer exists in the automation',
  },
  testar: {
    titulo: 'Test with me',
    texto: 'Runs the published version in a conversation of yours, with real messages: write from your phone to the company WhatsApp or Instagram, take the conversation and pick it here.',
    conversa: 'Test conversation',
    iniciar: 'Start the test',
    iniciado: 'Test started: check the conversation',
  },
};

const es: typeof pt = {
  aba: 'Automatizaciones',
  novo: 'Nueva automatización',
  gatilho: 'Disparador',
  gatilhos: { app: 'Evento de app externa (Maton)', palavra: 'Palabra clave en Direct o WhatsApp', comentario: 'Comentario en una publicación de Instagram', broadcast: 'Clic en botón de difusión (WhatsApp)' },
  nome: 'Nombre',
  canal: 'Canal',
  canais: { whatsapp: 'WhatsApp', instagram: 'Instagram', qualquer: 'WhatsApp y Instagram' },
  estados: { rascunho: 'Borrador', ativo: 'Activa', pausado: 'Pausada', arquivado: 'Archivada' },
  colunas: { nome: 'Automatización', canal: 'Canal', estado: 'Situación', versao: 'Versión', ativas: 'En curso', semana: 'Últimos 7 días', atualizada: 'Actualizada' },
  filtros: { todas: 'Todas', ativas: 'Activas', pausadas: 'Pausadas', rascunhos: 'Borradores', arquivadas: 'Archivadas' },
  semVersao: 'No publicada',
  versao: 'v{{n}}',
  vazio: 'Aún no hay automatizaciones de conversación. Crea la primera y dibuja el flujo en el lienzo.',
  vazioLeitura: 'Aún no hay automatizaciones de conversación.',
  criada: 'Automatización creada',
  semConversas: 'El módulo Conversaciones no está instalado: la automatización no envía nada hasta que lo esté.',
  editor: {
    voltar: 'Volver a las automatizaciones',
    renomear: 'Renombrar',
    salvando: 'Guardando…',
    salvo: 'Borrador guardado',
    pendente: 'Cambios por guardar',
    erroSalvar: 'No se pudo guardar el borrador',
    conflito: 'Esta automatización se cambió en otra pantalla.',
    recarregar: 'Recargar',
    publicada: 'Publicada (v{{n}})',
    naoPublicada: 'Cambios sin publicar',
    emDia: 'El borrador es igual a la versión publicada',
    desfazer: 'Deshacer',
    refazer: 'Rehacer',
    organizar: 'Organizar',
    simular: 'Simular',
    testar: 'Probar conmigo',
    versoes: 'Versiones',
    execucoes: 'Ejecuciones',
    pausar: 'Pausar',
    ativar: 'Activar',
    arquivar: 'Archivar',
    desarquivar: 'Desarchivar',
    publicar: 'Publicar',
    publicado: 'Versión {{n}} publicada',
    problemas_one: '{{count}} pendiente para publicar',
    problemas_other: '{{count}} pendientes para publicar',
    semProblemas: 'Listo para publicar',
    semPendencias: 'Sin pendientes',
    adicionar: 'Agregar caja',
    somenteLeitura: 'En el celular puedes ver, activar y desactivar la automatización. Para editar el flujo, usa la computadora.',
    arquivada: 'Automatización archivada: desarchívala para editar.',
    canvas: 'Flujo de la automatización',
    grupos: { mensagem: 'Mensajes', logica: 'Lógica', acao: 'Acciones', gatilho: 'Disparador' },
    estadoMudou: 'Situación actualizada',
    arquivarTitulo: '¿Archivar la automatización?',
    arquivarTexto: 'Los disparadores se detienen de inmediato; las conversaciones en curso terminan en su versión.',
  },
  tipos: { gatilho_palavra: 'Palabra clave', gatilho_comentario: 'Comentario en publicación', gatilho_broadcast: 'Clic en botón de difusión', resposta_publica: 'Respuesta pública', resposta_privada: 'Respuesta privada', oportunidade: 'Abrir oportunidad', mensagem: 'Mensaje', botoes: 'Botones', pergunta: 'Pregunta', condicao: 'Condición', espera: 'Espera', etiqueta: 'Etiqueta', transferir: 'Transferir', webhook: 'Webhook', gatilho_app: 'Evento de app externa', app_externo: 'Acción en app externa', fim: 'Fin' },
  saidas: { proximo: 'Después', sem_resposta: 'Sin respuesta', respondeu: 'Respondió', sim: 'Sí', nao: 'No', ok: 'Funcionó', erro: 'Falló' },
  resumo: {
    app: '{{app}} · {{evento}}',
    appSemEscolha: 'Elige la app y el evento',
    appExterno: '{{app}}: {{metodo}} {{caminho}}',
    post: 'Publicación: {{legenda}}',
    qualquerPost: 'Cualquier publicación',
    qualquerComentario: 'cualquier comentario',
    broadcast: 'Empieza cuando el contacto toca el botón vinculado a esta automatización en una difusión',
    oportunidade: 'Oportunidad: {{titulo}}',
    semPalavras: 'Sin palabra clave',
    palavras: '{{modo}}: {{lista}}',
    modos: { exata: 'Mensaje exacto', contem: 'Contiene', palavra: 'Palabra' },
    vazio: 'Sin texto',
    pergunta: 'Guarda en {{variavel}}',
    regras_one: '{{count}} regla ({{juncao}})',
    regras_other: '{{count}} reglas ({{juncao}})',
    juncoes: { todas: 'todas', alguma: 'alguna' },
    espera: '{{quantidade}} {{unidade}}',
    unidades: { minutos: 'min', horas: 'h', dias: 'días' },
    etiquetaPor: 'Pone "{{etiqueta}}"',
    etiquetaTirar: 'Quita "{{etiqueta}}"',
    filaPadrao: 'Cola predeterminada del canal',
    fila: 'Cola elegida',
    fim: 'Termina la automatización',
    arquivo: 'Con archivo',
  },
  painel: {
    broadcastTexto: 'Esta automatización empieza cuando el contacto toca un botón de una difusión del Broadcast. En la difusión (Automatizaciones > Broadcast), vincula el botón a esta automatización. Solo en WhatsApp y solo para automatizaciones del grupo.',
    appTexto: 'Cuando el evento ocurre en la app, Maton avisa a MalgoOS y el flujo corre sin conversación: usa condición, espera, webhook y acción en app externa. El evento llega en las variables {{a}}, {{b}} y las demás que empiezan por evento_ ({{c}} trae todo).',
    appFonte: 'App',
    appEvento: 'Evento',
    escolha: 'Elige',
    conexao: 'Cuenta de la app (conexión de Maton)',
    conexaoAjuda: 'Las cuentas quedan en Maton: créalas en Integraciones > Conectores > Maton.',
    conexaoOutra: 'Conexión {{id}}',
    semConexoes: 'Ninguna cuenta activa de esta app en Maton.',
    gatilhoMaton: 'Disparador en Maton',
    criarNaMaton: 'Crear en Maton',
    gatilhoCriado: 'Disparador creado en Maton',
    gatilhoFalta: 'Elige app, evento y cuenta y usa "Crear en Maton": Maton pasa a avisar a MalgoOS de ese evento.',
    appExternoTexto: 'Llama a la API de la app por Maton, con la cuenta elegida. Solo las llamadas de la lista de la app (leer, crear, añadir, actualizar); borrar no está permitido.',
    modelo: 'Empezar de una plantilla',
    modelos: { sheets_linha: 'Google Sheets: añadir fila', hubspot_contato: 'HubSpot: crear contacto', hubspot_negocio: 'HubSpot: crear negocio' },
    appAcao: 'App',
    metodo: 'Método',
    caminho: 'Ruta de la API de la app',
    caminhoAjuda: 'Empieza por /, sin el nombre de la app (ej.: /crm/v3/objects/contacts). Variables como {{v}} van codificadas.',
    corpo: 'Cuerpo (JSON)',
    corpoAjuda: 'Variables dentro de las comillas, como "{{v}}". Una llamada GET va sin cuerpo.',
    variavelResposta: 'Guardar la respuesta en la variable',
    variavelRespostaAjuda: 'Vacío: no guarda. Con id en la respuesta, el id va también a <variable>_id.',
    funilIndisponivel: 'Embudo no disponible (archivado o sin acceso)',
    segueAjuda: 'Pregunta a Meta si el contacto sigue la cuenta de Instagram. Sin respuesta de Meta, sigue por la salida "No".',
    tipoGatilho: 'Tipo de disparador',
    tipoGatilhoAjuda: 'Cambiar el tipo borra la configuración del disparador; las conexiones se mantienen.',
    post: 'Publicación',
    qualquerPost: 'Cualquier publicación',
    escolherPost: 'Elegir publicación',
    verPost: 'Ver en Instagram',
    semLegenda: 'Publicación sin texto',
    semPosts: 'La cuenta no tiene publicaciones.',
    carregarMais: 'Cargar más',
    carregandoPosts: 'Cargando publicaciones…',
    fecharLista: 'Cerrar la lista',
    tentarDeNovo: 'Intentar de nuevo',
    filtroComentario: 'Comentarios que disparan',
    filtros: { todos: 'Cualquier comentario', palavras: 'Solo con palabras clave' },
    comentarioRegras: 'No dispara con comentarios de la propia cuenta ni con respuestas dentro de otro comentario. Una automatización por persona a la vez.',
    publicaTexto: 'Responde debajo del comentario, en la propia publicación. Una respuesta pública por comentario.',
    privadaTexto: 'Abre el Direct con quien comentó. Una por comentario, hasta 7 días después y hasta 750 por hora por cuenta (por encima, espera el siguiente cupo).',
    textoComentarioAjuda: 'Usa {{usuario}} para el @ de quien comentó y {{comentario}} para el texto del comentario.',
    semOpcoes: 'Sin opciones: el flujo sigue directo por la salida "Después".',
    oportunidadeTexto: 'Abre una oportunidad en el Pipeline para el contacto de la conversación. Si la conversación ya tiene una abierta, usa esa.',
    tituloOportunidade: 'Título de la oportunidad',
    funil: 'Embudo',
    funilPadrao: 'Embudo predeterminado',
    titulo: 'Editar caja',
    excluir: 'Eliminar caja',
    leitura: 'Solo lectura',
    texto: 'Texto',
    textoAjuda: 'Usa {{variavel}} para insertar una variable (ej.: {{email}}).',
    palavraVariavel: 'variable',
    canal: 'Canal',
    palavras: 'Palabras clave',
    palavrasAjuda: 'Una por línea.',
    modo: 'Cómo coincide',
    modos: { palavra: 'Palabra entera en el mensaje', contem: 'Contiene el texto', exata: 'El mensaje entero' },
    arquivo: 'Archivo (solo WhatsApp)',
    enviarArquivo: 'Subir archivo',
    tirarArquivo: 'Quitar archivo',
    arquivoEnviado: 'Archivo subido',
    tipoBotoes: 'Tipo',
    modosBotoes: { botoes: 'Botones (hasta 3)', respostas_rapidas: 'Respuestas rápidas (hasta 10)' },
    modosBotoesInstagram: { botoes: 'Botones (hasta 3)', respostas_rapidas: 'Respuestas rápidas (hasta 13)' },
    opcoes: 'Opciones',
    opcao: 'Opción {{n}}',
    novaOpcao: 'Agregar opción',
    tirarOpcao: 'Quitar la opción {{n}}',
    prazo: 'Plazo para responder (horas)',
    prazoAjuda: 'Vacío: espera sin plazo. Con plazo, la caja gana la salida "Sin respuesta".',
    variavel: 'Guardar la respuesta en la variable',
    formato: 'Formato de la respuesta',
    formatos: { texto: 'Texto', numero: 'Número', email: 'Correo', telefone: 'Teléfono' },
    invalida: 'Mensaje cuando la respuesta no sirve',
    juncao: 'Vale cuando',
    juncoes: { todas: 'Todas las reglas valen', alguma: 'Alguna regla vale' },
    regra: 'Regla {{n}}',
    novaRegra: 'Agregar regla',
    tirarRegra: 'Quitar la regla {{n}}',
    campo: 'Verificar',
    campos: { segue: 'Sigue la cuenta (Instagram)', variavel: 'Variable', etiqueta: 'Etiqueta de la conversación', horario: 'Día y horario', canal: 'Canal' },
    operador: 'Comparación',
    operadores: { segue: 'Sigue la cuenta', nao_segue: 'No sigue la cuenta', igual: 'Es igual a', diferente: 'Es distinto de', contem: 'Contiene', existe: 'Está llena', nao_existe: 'Está vacía', maior: 'Mayor que', menor: 'Menor que', tem: 'Tiene', nao_tem: 'No tiene' },
    valor: 'Valor',
    dias: 'Días de la semana',
    diasSemana: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    inicio: 'Desde',
    fim: 'Hasta',
    quantidade: 'Cuánto tiempo',
    unidade: 'Unidad',
    unidades: { minutos: 'Minutos', horas: 'Horas', dias: 'Días' },
    acaoEtiqueta: 'Qué hacer',
    acoesEtiqueta: { por: 'Poner la etiqueta', tirar: 'Quitar la etiqueta' },
    etiqueta: 'Etiqueta',
    fila: 'Cola',
    filaPadrao: 'Cola predeterminada del canal',
    mensagemTransferir: 'Mensaje antes de transferir (opcional)',
    url: 'Dirección (https)',
    urlAjuda: 'Recibe un POST con las variables, firmado con el secreto de la automatización (encabezado X-ERP-Signature).',
    segredo: 'Generar secreto del webhook',
    segredoTitulo: 'Secreto del webhook',
    segredoTexto: 'Cópialo ahora: no aparece de nuevo. Úsalo para verificar la firma en tu sistema.',
    copiar: 'Copiar',
    copiado: 'Copiado',
    fimTexto: 'La automatización termina aquí.',
  },
  versoes: { titulo: 'Versiones publicadas', atual: 'En uso', restaurar: 'Restaurar en el borrador', restaurada: 'Versión {{n}} traída al borrador', caixas_one: '{{count}} caja', caixas_other: '{{count}} cajas', vazio: 'Nada publicado aún.', por: 'por {{nome}}' },
  execucoes: {
    titulo: 'Ejecuciones',
    vazio: 'Ninguna ejecución aún.',
    estados: { rodando: 'En ejecución', aguardando: 'Esperando', concluida: 'Concluida', falhou: 'Falló', cancelada: 'Cancelada' },
    origens: { app_externo: 'Evento de app', comentario: 'Comentario', gatilho: 'Disparador', botao: 'Botón', teste: 'Prueba' },
    contato: 'Contacto',
    inicio: 'Inicio',
    passos: 'Pasos',
    cancelar: 'Cancelar ejecución',
    cancelada: 'Ejecución cancelada',
    resultados: { ok: 'OK', erro: 'Error', aguardando: 'Esperando' },
    ate: 'hasta {{quando}}',
  },
  simulador: {
    evento: 'Evento de ejemplo: {{app}} · {{evento}}',
    appSemEscolha: 'Elige la app y el evento en el disparador para simular.',
    segue: 'El contacto sigue la cuenta',
    respondeuDirect: 'En el Direct, el contacto aún no respondió: el siguiente mensaje solo sale después del toque o de la respuesta.',
    comentario: 'Comentario del contacto en la publicación',
    comentarioExemplo: 'Ej.: quiero el enlace',
    comentou: 'Comentó: {{texto}}',
    naoCasa: 'El comentario no activa el disparador (revisa las palabras clave).',
    publica: 'Respuesta pública',
    privada: 'Respuesta privada (Direct)',
    semDirect: 'La conversación de Direct solo existe después de la respuesta privada al comentario',
    titulo: 'Simular',
    texto: 'Ejecuta el borrador aquí en la pantalla, sin enviar nada a nadie.',
    iniciar: 'Empezar por el disparador',
    reiniciar: 'Reiniciar',
    responder: 'Responder como el contacto',
    enviar: 'Enviar',
    tempo: 'Saltar la espera',
    canal: 'Canal de la simulación',
    etiquetas: 'Etiquetas de la conversación',
    terminou: 'Automatización terminada: {{motivo}}',
    concluida: 'concluida',
    aguardando: 'Esperando {{oque}}',
    esperas: { app_externo: 'la respuesta de la app externa', repetir: 'el siguiente cupo de respuesta privada', clique: 'el toque en un botón', resposta: 'la respuesta', tempo: 'el tiempo' },
    acao: { appExterno: 'App externa llamada (simulada): {{app}} {{metodo}} {{caminho}}', oportunidade: 'Oportunidad abierta (simulada): {{titulo}}', etiqueta: 'Etiqueta: {{acao}} "{{etiqueta}}"', transferir: 'Conversación entregada al equipo', webhook: 'Webhook llamado (simulado): {{url}}' },
    arquivo: 'Archivo: {{nome}}',
    problemas: 'El borrador tiene pendientes; la simulación puede detenerse en ellos.',
  },
  motivos: {
    evento_inexistente: 'Evento de la app no encontrado', app_externo_parado: 'La app externa no respondió (la automatización se detuvo)',
    canal_desconectado: 'El canal no está conectado en Integraciones',
    janela_fechada: 'Pasaron 24 horas desde el último mensaje del contacto: el mensaje automático no sale (en WhatsApp, solo plantilla aprobada)',
    direct_sem_resposta: 'En el Direct abierto por la respuesta privada, el siguiente mensaje solo sale después de que la persona responde',
    botoes_canal: 'Botones y respuestas rápidas solo salen por WhatsApp oficial e Instagram',
    publica_repetida: 'Este comentario ya recibió la respuesta pública',
    comentario_proprio: 'Comentario de la propia cuenta: la automatización no se responde a sí misma',
    privada_repetida: 'Este comentario ya recibió la respuesta privada (Meta acepta una por comentario)',
    comentario_7dias: 'Pasaron 7 días desde el comentario: Meta ya no acepta la respuesta privada',
    sem_contato: 'La conversación no tiene contacto en Registros para abrir la oportunidad',
    sem_pipeline: 'Instala el módulo Pipeline para abrir oportunidades',
    sem_direct: 'La conversación de Direct solo existe después de la respuesta privada al comentario',
    nao_comentario: 'Esta ejecución no empezó por un comentario',
    comentario_inexistente: 'Comentario no encontrado', sem_gatilho: 'Flujo sin disparador', caixa_inexistente: 'Caja que no existe en esta versión', variaveis_demais: 'Demasiadas variables en la ejecución',
    limite_passos: 'Superó el límite de pasos (bucle sin espera)', ligacao_gatilho: 'Conexión de vuelta al disparador', transferida: 'Transferida al equipo',
    conversas_indisponivel: 'El módulo Conversaciones no está disponible', conversa_inexistente: 'Conversación no encontrada', envio_recusado: 'El proveedor rechazó el mensaje',
    execucao_parada: 'La ejecución se detuvo (el servidor no pudo continuar)', sem_resposta_prazo: 'Sin respuesta en 7 días', conversa_encerrada: 'Conversación cerrada',
    duplicada: 'Ya había otra ejecución en curso en la conversación', cancelada_tela: 'Cancelada en la pantalla', erro_interno: 'Error interno al ejecutar la caja', arquivo_inexistente: 'El archivo del mensaje ya no existe en la automatización', webhook_parado: 'El webhook no respondió (la automatización se detuvo)',
  },
  passos: {
    app_externo: 'Llamando a la app externa', maton_sem_conector: 'Conecta Maton en Integraciones > Conectores', maton_caminho_bloqueado: 'Llamada fuera de la lista permitida (con las variables)', maton_corpo_invalido: 'El cuerpo quedó inválido con las variables', maton_limite: 'Maton limitó las solicitudes (10 por segundo)', maton_bloqueado: 'Destino de Maton bloqueado', maton_sem_resposta: 'Maton no respondió en el plazo',
    limite_hora: 'La cuenta llegó a 750 respuestas privadas en la última hora (límite de Meta): nuevo intento a las {{quando}}', resposta_publica: 'Respuesta pública programada', resposta_privada: 'Respuesta privada enviada', oportunidade_aberta: 'Oportunidad abierta en el Pipeline', oportunidade_existente: 'La conversación ya tenía una oportunidad abierta', espera_concluida: 'Espera concluida', sem_resposta: 'Sin respuesta en el plazo', clique: 'Botón tocado', resposta_opcao: 'Respuesta con el texto de la opción',
    conversa_inexistente: 'Conversación no encontrada',
    comentario_inexistente: 'Comentario no encontrado',
    canal_desconectado: 'El canal no está conectado en Integraciones',
    janela_fechada: 'Pasaron 24 horas desde el último mensaje del contacto: el mensaje automático no sale (en WhatsApp, solo plantilla aprobada)',
    direct_sem_resposta: 'En el Direct abierto por la respuesta privada, el siguiente mensaje solo sale después de que la persona responde',
    botoes_canal: 'Botones y respuestas rápidas solo salen por WhatsApp oficial e Instagram',
    publica_repetida: 'Este comentario ya recibió la respuesta pública',
    comentario_proprio: 'Comentario de la propia cuenta: la automatización no se responde a sí misma',
    privada_repetida: 'Este comentario ya recibió la respuesta privada (Meta acepta una por comentario)',
    comentario_7dias: 'Pasaron 7 días desde el comentario: Meta ya no acepta la respuesta privada',
    sem_contato: 'La conversación no tiene contacto en Registros para abrir la oportunidad',
    sem_pipeline: 'Instala el módulo Pipeline para abrir oportunidades',
    sem_direct: 'La conversación de Direct solo existe después de la respuesta privada al comentario',
    nao_comentario: 'Esta ejecución no empezó por un comentario',
    resposta_invalida: 'Respuesta inválida, se preguntó de nuevo', resposta_guardada: 'Respuesta guardada en {{valor}}', esperando_clique: 'Esperando el toque',
    esperando_resposta: 'Esperando la respuesta', ate: 'Hasta {{quando}}', transferida: 'Conversación entregada a la cola', webhook: 'Llamando al webhook', http: 'HTTP {{status}}',
    webhook_sem_segredo: 'Genera el secreto del webhook en la pantalla de la automatización', webhook_bloqueado: 'Destino del webhook bloqueado', webhook_sem_resposta: 'El webhook no respondió en el plazo',
    arquivo_enviado: 'Archivo enviado', envio_recusado: 'El proveedor rechazó el mensaje', erro_interno: 'Error interno al ejecutar la caja', arquivo_inexistente: 'El archivo del mensaje ya no existe en la automatización',
  },
  testar: {
    titulo: 'Probar conmigo',
    texto: 'Ejecuta la versión publicada en una conversación tuya, con mensajes reales: escribe desde tu teléfono al WhatsApp o Instagram de la empresa, asume la conversación y elígela aquí.',
    conversa: 'Conversación de prueba',
    iniciar: 'Empezar la prueba',
    iniciado: 'La prueba empezó: mira la conversación',
  },
};

export const fluxosI18n = { pt, en, es };
